import { NavLink } from "react-router-dom";

const tabs = [
  { to: "/local/stream", label: "Mi Stream" },
  { to: "/local/editor", label: "Editor de Layout" },
  { to: "/local/archivos", label: "Mis Archivos" },
  { to: "/local/horarios", label: "Horarios" },
];

export default function TabNav() {
  return (
    <nav
      className="bg-white border-b border-line px-5 flex items-center gap-1"
      style={{ height: 44 }}
    >
      {tabs.map((t) => (
        <NavLink
          key={t.to}
          to={t.to}
          className={({ isActive }) =>
            [
              "relative h-full flex items-center px-4 text-sm transition-colors duration-150",
              isActive
                ? "font-semibold text-navy"
                : "text-gray-500 hover:text-navy",
            ].join(" ")
          }
        >
          {({ isActive }) => (
            <>
              {t.label}
              <span
                className={[
                  "absolute left-3 right-3 bottom-0 h-[2.5px] rounded-t-full bg-teal transition-opacity duration-150",
                  isActive ? "opacity-100" : "opacity-0",
                ].join(" ")}
              />
            </>
          )}
        </NavLink>
      ))}
    </nav>
  );
}
